/* eslint-disable */
/* eslint-disable react/prop-types */
import { Typography, Grid, Button } from '@material-ui/core';
import React from 'react';
import BoralLogoUrl from '../../Assets/Logos/Boral-84x69.png';
import ChromeLogoUrl from '../../Assets/Logos/chrome.png';
import SafariLogoUrl from '../../Assets/Logos/safari.png';
import EdgeLogoUrl from '../../Assets/Logos/edge.png';
import FirefoxLogoUrl from '../../Assets/Logos/firefox.png';
import browserNotSupportedStyles from './BrowserNotSupported.component.styles';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';

const chromeUrl = 'https://www.google.com.au/chrome/';
const edgeUrl = 'https://www.microsoft.com/en-us/edge';
const safariUrl = 'https://support.apple.com/en_AU/downloads/safari';
const firefoxUrl = 'https://www.mozilla.org/en-US/firefox/new/';

/**
 * BrowserNotSupported
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const BrowserNotSupported = ({ classes}) => {
  return (
    <div className={classes.pageWrapper}>
      <Grid container spacing={2} className={classes.containerWrapper}>
        <Typography variant="body2" className={classes.browserNotSupported}>
          Browser Not Supported
        </Typography>
        <Grid item xs={12}>
          <img src={BoralLogoUrl} alt="Boral logo" height="75" className={classes.imgBoralLogo} />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6" className={cn(classes.fontWeight500, classes.marginBottom3unit)}>
            Boral Connects
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h1" className={classes.h1}>
            Please upgrade your browser
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1" className={classes.content}>
            We've built Boral Connects using the latest technology. This makes Boral Connects faster and easier to use. Unfortunately, your browser doesn't
            support those technologies. Download one of these great browsers and you'll be on your way.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2} className={classes.logosWrapper}>
            <Grid item xs={6} sm={3}>
              <Button  className={classes.button} onClick={() => window.open('//www.boral.com.au/privacy-policy', '_blank')}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <img src={ChromeLogoUrl} alt="Chrome logo" />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" className={classes.browserLink}>
                      Chrome
                    </Typography>
                  </Grid>
                </Grid>
              </Button>
            </Grid>
            <Grid item xs={6} sm={3}>
              <Button  className={classes.button} onClick={() => window.open('//www.boral.com.au/privacy-policy', '_blank')}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <img src={FirefoxLogoUrl} alt="Firefox logo" />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" className={classes.browserLink}>
                      Firefox
                    </Typography>
                  </Grid>
                </Grid>
              </Button>
            </Grid>
            <Grid item xs={6} sm={3}>
              <Button  className={classes.button} onClick={() => window.open('//www.boral.com.au/privacy-policy', '_blank')}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <img src={SafariLogoUrl} alt="Safari logo" />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" className={classes.browserLink}>
                      Safari
                    </Typography>
                  </Grid>
                </Grid>
              </Button>
            </Grid>
            <Grid item xs={6} sm={3}>
              <Button  className={classes.button} onClick={() => window.open('//www.boral.com.au/privacy-policy', '_blank')}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <img src={EdgeLogoUrl} alt="Edge logo" />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" className={classes.browserLink}>
                      Edge
                    </Typography>
                  </Grid>
                </Grid>
              </Button>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="body1" className={classes.content}>
            Already upgraded and still seeing this screen? Please email{' '}
            <a rel="noopener noreferrer" className={classes.hyperlink} href="mailto:cx@boral.com.au">
              cx@boral.com.au
            </a>
            .
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};

export default compose(withStyles(themeCreateInjectableStyles(browserNotSupportedStyles), { withTheme: true }))(BrowserNotSupported);
